import React, {useEffect, useState} from 'react';
import {makeStyles} from "@mui/styles";
import {InfoBanner} from "../ui/InfoBanner";
import {useIntegrationsContext} from "../../api/integrations/IntegrationsContext";
import {useHistory, useParams} from "react-router";
import {GetIntegrationItemProps} from "../../api/integrations/IntegrationsDTO";
import {showError} from "../../utils/NotificationUtils";
import {IntegrationAuthSteps} from "./auth/IntegrationAuthSteps";
import {Loader} from "../ui/Loader";
import {AuthTypesInfo} from "../../constants/AppConstants";
import {useI18n} from "../../i18n/I18nContext";
import {AppButton} from '../ui/AppButton';
import DeleteIcon from '@mui/icons-material/Delete';
import {DialogWindow} from "../ui/DialogWindow";
import {toast} from "react-toastify";
import {pathParams} from "path-params";
import {Routes} from "../../constants/Routes";

const useStyles = makeStyles(() => ({
    root: {
        padding: 40,
    },
    container: {
        maxWidth: 1100,
        margin: "0 auto"
    },
    type: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    }
}));

export function IntegrationAuthEditor() {
    const classes = useStyles();
    const {IntegrationsApi} = useIntegrationsContext();
    const [loading, setLoading] = useState(true);
    const params: any = useParams();
    const {translate} = useI18n();
    const history = useHistory();
    const [showDialog, setShowDialog] = useState(false);

    const [data, setData] = useState<GetIntegrationItemProps | null>(null);

    useEffect(() => {
        IntegrationsApi.getIntegrationAuth({params: {integrationId: params.id}}).then(res => {
            setData(res.payload);
            setLoading(false)
        }).catch(err => {
            showError(err);
            setLoading(false)
        })
    }, [IntegrationsApi, params]);

    const handleDataChange = (name: string, value: any) => {
        //@ts-ignore
        setData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const onDelete = (id: number) => {
        IntegrationsApi.deleteAuth({params: {authId: id}}).then(() => {
            history.replace(pathParams(Routes.IntegrationEditorAuth , {id: params.id}));
            toast.success("Deleted");
            setShowDialog(false);
        }).catch(err => {
            showError(err)
        })
    };

    return (
        <div className={classes.root}>
            {loading ? (
                <Loader/>
            ) : (
                <div className={classes.container}>
                    <div className={classes.type}>
                        <h3>{data?.authType}</h3>
                        <AppButton background="#ff4754" onClick={() => setShowDialog(true)} textColor="#fff"><DeleteIcon/>Delete</AppButton>
                    </div>
                    <InfoBanner  title={translate(AuthTypesInfo[data ? data.authType : "API_KEY"].title)}
                                description={translate(AuthTypesInfo[data ? data.authType : "API_KEY"].description)}/>
                    <IntegrationAuthSteps onChange={handleDataChange} fields={data?.fields} code={""} data={data}/>

                    <DialogWindow
                        show={showDialog}
                        onClose={() => setShowDialog(false)}
                        onCancel={() => console.log("hello")}
                        onAgree={() => onDelete(params.authId)}
                        >
                        Are you sure?
                    </DialogWindow>
                </div>
            )}
        </div>
    );
}

